import { render, staticRenderFns } from "./detalle_articulo.vue?vue&type=template&id=e010fae0&scoped=true&"
import script from "./detalle_articulo.vue?vue&type=script&lang=js&"
export * from "./detalle_articulo.vue?vue&type=script&lang=js&"
import style0 from "./detalle_articulo.vue?vue&type=style&index=0&id=e010fae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e010fae0",
  null
  
)

export default component.exports